import { PropsWithChildren, useEffect, useState } from "react";

import { useCloudStatusRedirection, useCloudStatus } from "../../hooks";

/**
 * Component that will hide it's children if a redirect to product is iminent.  This prevents a flicker of child elements.
 * @param children - the children to render
 * @returns {JSX.Element}
 */
export const ProductRedirector = ({ children }: PropsWithChildren) => {
    const { createCloudStatus } = useCloudStatus();
    const { setWaitingForProvisioning } = useCloudStatusRedirection();

    // check if create cloud status is a success on first render
    const [shouldRedirect] = useState(createCloudStatus === "success");

    // inform cloud status the user is waiting for provisioning to complete.
    useEffect(() => {
        setWaitingForProvisioning(true);
    }, []);

    // Do not show children. A redirect to product is imminent
    // This redirect will happen in use-cloud-status.tsx
    if (shouldRedirect === true) {
        return null;
    }

    return children;
};
